import { ParticipantView, QuestionView } from '@views';
import { useSaveSurveyResponsesAction } from '@actions';
import { useEffect, useState } from 'react';
import { useOnboardingSurveyViewCreator } from '@viewCreators/onboarding-survey-view-creator';
import { EmptyFunction } from '@utils/common-types';
import { useActiveParticipantsViewCreator } from '@viewCreators/active-participants-view-creator';
import { useNavigationEligibility } from '@components/SurveyDrawer/NavigationEligibilityContextProvider';
import Logger from '@utils/logger';
import { DateTime } from 'luxon';

export type SurveyDrawerController = {
  surveyTitle: string;
  isDrawerOpen: boolean;
  activeStep: number;
  currentQuestion: QuestionView;
  questions: QuestionView[];
  handleNext: EmptyFunction;
  handlePrev: EmptyFunction;
  saveResponses: () => void;
  refresh: () => Promise<any>;
  activeParticipants: ParticipantView[];
};

export const useSurveyDrawerController = (groupId: number): SurveyDrawerController => {
  const { data: section, refetch } = useOnboardingSurveyViewCreator(groupId);
  const [activeStep, setActiveStep] = useState<number>(0);
  const { mutateAsync: saveSurveyAction } = useSaveSurveyResponsesAction();
  const [currentQuestion, setCurrentQuestion] = useState<QuestionView>(null as unknown as QuestionView);
  const [questions, setQuestions] = useState<QuestionView[]>([]);
  const [surveyTitle, setSurveyTitle] = useState<string>('');
  const { data: participants } = useActiveParticipantsViewCreator(groupId);
  const { setSectionRef, setCurrentStep, triggerEligibility } = useNavigationEligibility();
  useEffect(() => {
    if (section) {
      setSectionRef(section);
      setSurveyTitle(section.title);

      const allQuestions = section?.questions ?? [];
      setQuestions(allQuestions);

      const step = Math.min(activeStep, allQuestions.length - 1);
      setCurrentQuestion(allQuestions[step]);
      triggerEligibility();
    }
  }, [section, activeStep]);

  const isDrawerOpen = (section && section.id !== 1 && (section.questions?.length || 0) > 0) || false;

  const handleNext = () => {
    setActiveStep((prev) => {
      const next = prev + 1;
      setCurrentStep(next);
      return next;
    });
  };

  const handlePrev = () => {
    setActiveStep((prev) => {
      const next = prev - 1;
      setCurrentStep(next);
      return next;
    });
  };

  const handleSaveResponses = async () => {
    // view.section!.questions = [...questions];
    if (section) {
      await saveSurveyAction({ section, groupId });
    }
    await refetch();
  };
  const activeParticipants = participants ?? [];
  return {
    isDrawerOpen,
    questions,
    activeStep,
    surveyTitle,
    currentQuestion,
    handleNext,
    handlePrev,
    saveResponses: handleSaveResponses,
    refresh: refetch,
    activeParticipants,
  };
};
